export const matrix = {
  configFor: 'Szablon konfiguracji dla',
  title: 'Drzewiasty podgląd produktów i przywiązań',
  possibilities: 'Możliwości',
  noData: 'Brak danych do wyświetlenia',
  closeAll: 'Zamknij wszystko',
  openAll: 'Otwórz wszystko',
  all: 'Wszystkie',
  active: 'Z przypisanymi szablonami konfiguracjami',
  inactive: 'Bez przypisanych szablonów konfiguracji',
} as const
